import React from 'react'

import AdmissionFee from './BillingAdmissionFee'
import RefundableDep from './BillingRefundableDep'
import AdvanceUse from './BillingAdvanceUse'
import AnnualRegi from './BillingAnnualRegi'
import TransferFee from './BillingTransferFee'
import Caddies from './BillingCaddies'

import { 
  Col, 
  Row,
  Tabs,
} from 'antd';

const { TabPane } = Tabs;

const OtherBilling = ({memberDetails, fetchMembersData, isLoading, id}) => {
    return (
        <Row className='tab-container custom-padding'>
            <Col xs={12} sm={12} md={24} lg={24} xl={24}>
                <Tabs
                    id="PO-tabs"
                    type="card"
                    animated="true"
                    size="medium"
                >
                    <TabPane key="admission_fee" tab="Admission Fee">
                        <AdmissionFee
                            admissionData={memberDetails?.admission_fee}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                        />
                    </TabPane>

                    <TabPane key="refundable_dep" tab="Refundable Dep">
                        <RefundableDep
                            refundableData={memberDetails?.refundable_dep}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                        />
                    </TabPane>
                   
                    <TabPane key="advance_use" tab="Advance Use">
                        <AdvanceUse
                            advanceData={memberDetails?.advance_use}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                        />
                    </TabPane>
                    
                    <TabPane key="first_annual" tab="1st Annual Regi">
                        <AnnualRegi
                            annualData={memberDetails?.first_annual}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                        />
                    </TabPane>
                    
                    <TabPane key="transfer_fee" tab="Transfer Fee">
                        <TransferFee
                            transferData={memberDetails?.transfer_fee}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                        />
                    </TabPane>

                    <TabPane key="caddies" tab="Caddies/GC">
                        <Caddies
                            caddiesData={memberDetails?.caddies}
                            fetchMembersData={fetchMembersData}
                            isLoading={isLoading}
                            id={id}
                        />
                    </TabPane>
                </Tabs>
            </Col>
        </Row>
    )
}

export default OtherBilling
